<div class="container" [ngStyle]="{'background': getBackground()}" [ngClass]="{
  'tamanho-1-margem': config.tamanho == 1 && config.margem_botao == 1,
  'tamanho-1-sem-margem': config.tamanho == 1 && config.margem_botao == 0,
  'tamanho-2-margem': config.tamanho == 2 && config.margem_botao == 1,
  'tamanho-2-sem-margem': config.tamanho == 2 && config.margem_botao == 0,
  'tamanho-3': config.tamanho == 3,
  'tamanho-4': config.tamanho == 4,
  'tamanho-5': config.tamanho == 5,
  'tamanho-5-config-margem': config.tamanho == 5,
  'margin-left-img': config.ordem == 1 && config.tamanho == 5,
  'margin-right-img': config.ordem == 2 && config.tamanho == 5,
  'margem': config.margem_botao == 1,
  'not-margem': config.margem_botao == 0,
  'margin-right': config.tamanho == 1 && config.ordem == 1 && config.margem_botao == 1,
  'margin-left': config.tamanho == 1 && config.ordem == 2 && config.margem_botao == 1
}">
  <div *ngIf="config.mostrar_label == 1" [ngClass]="{
    'bottom-left': config.font_align == 'left',
    'centered': config.font_align == 'center',
    'centered-left': config.font_align == 'center-left',
    'negrito-1' : config.negrito == 1,
    'negrito-2' : config.negrito == 2,
    'negrito-3' : config.negrito == 3
  }">
    <span class="descricao"
      [ngStyle]="{'font-size': getFontSize(), 'font-weight': getFontWeight(), 'color': getFontColor()}">
      {{config.label}}
      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'MensagemPage' && mensagemProvider.getTotalMensagensNaoLidas() != 0"
        color="danger">
        {{mensagemProvider.getTotalMensagensNaoLidas()}}
      </ion-badge>

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'OracaoPage' && oracaoProvider.getAdminTotal() != 0"
        color="danger">
        {{oracaoProvider.getAdminTotal()}}
      </ion-badge>

      <ion-badge
        *ngIf="!userProvider.isAnonimo() && config.target_url == 'NoticiaPage' && noticiaProvider.getTotalNaoLidas() != '0'"
        color="danger">
        {{noticiaProvider.getTotalNaoLidas()}}
      </ion-badge>

    </span>
  </div>
</div>